import { Alert, Box, Stack, styled, Typography } from '@mui/material';

export const MinorPoADrawerContainer = styled(Box)({
  display: 'flex',
  alignItems: 'center',
  flexDirection: 'column',
  justifyContent: 'flex-start',
  flex: 1,
  minHeight: 0,
  width: '100%',
});

export const FormContainer = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'stretch',
  width: '100%',
  padding: theme.spacing(2),
  gap: theme.spacing(3),

  '& > *': {
    marginLeft: 0,
  },

  '& .MuiButton-root': {
    width: '100%',
    maxWidth: '100%',
  },

  '& .MuiFormControl-root': {
    marginLeft: 0,
  },
}));

export const AddressHeader = styled(Typography)({
  textAlign: 'center',
  width: '100%',
  maxWidth: 400,
});

export const ShareAddressToggleContainer = styled(Box)(({ theme }) => ({
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  gap: theme.spacing(2),
  width: '100%',
}));

export const ShareAddressAlert = styled(Alert)(({ theme }) => ({
  backgroundColor: theme.palette.neutral[200],
  '& .MuiAlert-message': {
    color: theme.palette.neutral[1000],
    fontWeight: theme.typography.fontWeightRegular,
  },
  '& .MuiAlert-icon .MuiSvgIcon-root': {
    fill: theme.palette.neutral[700],
  },
}));

export const ShareAddressBox = styled(Box)(({ theme }) => ({
  gap: theme.spacing(1),
  display: 'flex',
  flexDirection: 'column',
}));

export const ShareAddressDescription = styled(Typography)(({ theme }) => ({
  color: theme.palette.text.secondary,
  maxWidth: 288,
}));

export const AddressFieldsStack = styled(Stack)({
  display: 'flex',
  flexDirection: 'column',
  width: '100%',
  maxWidth: '100%',

  '& > *': {
    marginLeft: 0,
  },

  '& .MuiFormControl-root': {
    marginLeft: 0,
  },
});
